import React from "react";

export default class Next extends React.Component {
  constructor(props) {
    super(props);
  }

  cb = () => {

  }

  render() {
    const btnClass = this.props.btnClass ? this.props.btnClass : "btn btn-light";
    const callBack = this.props.callback ? this.props.callback : this.cb;
    const text = this.props.text ? this.props.text : 'Next';
    const disabled = this.props.disabled ? {disabled: "disabled"} : false;
    return (
      <div id="next">
        <div className="container">
          {(this.props.placeholder) ?
            (
              <>{this.props.placeholder}</>
            )
            :
            (
              <button className={btnClass + ' w-100'} onClick={this.props.callback} {...disabled}>{text}</button>
            )
          }
        </div>
      </div>
    );
  }
}
